import * as AT from './actionTypes'

export { AT }

export type ZendeskActionType = { readonly type: string }

export const openChat = (): ZendeskActionType => ({
  type: AT.OPEN_CHAT
})

export const closeChat = (): ZendeskActionType => ({
  type: AT.CLOSE_CHAT
})

export const showChatButton = (): ZendeskActionType => ({
  type: AT.SHOW_CHAT_BUTTON
})

export const hideChatButton = (): ZendeskActionType => ({
  type: AT.HIDE_CHAT_BUTTON
})
